import Navbar from "./Navbar";
import Hero from "./Hero";
import { StatsBar, AnalysisProcess, Testimonials } from "./SocialProof";
import { Offer, HowItWorks, Trust } from "./Sections";
import { MainCTA, Footer, StickyMobileCTA } from "./Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen font-body">
      <Navbar />
      <main>
        <Hero />
        <Offer />
        <StatsBar />
        <Testimonials />
        <AnalysisProcess />
        <HowItWorks />
        <Trust />
        <MainCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
